import AccountSideMenu from './AccountSideMenu';
import styles from './style.module.css';
import {ComponentWithChildrenProps} from '@interfaces/component';

interface AccountLayoutProps extends ComponentWithChildrenProps {
  contentClassNames?: string;
  title?: string;
  page: string;
}

export default function AccountLayout(props: AccountLayoutProps) {
  const {children, title, page, contentClassNames = ''} = props;

  return (
    <div className={'container'}>
      <div className="row">
        <div className="col-12">
          <div className={styles.accountLayout}>
            <AccountSideMenu page={page} />
            <div
              className={`${styles.accountLayoutContent} ${contentClassNames}`}
            >
              <div className="container">
                <h3>{title}</h3>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
